// From https://github.com/maciel310/angular-filesystem/blob/master/src/filesystem.js

function FilesystemService($q, $timeout, $http) {
    "ngInject";

    let fsDefer = $q.defer();

    let DEFAULT_QUOTA_MB = 0;

    window.resolveLocalFileSystemURL = window.resolveLocalFileSystemURL || window.webkitResolveLocalFileSystemURL;
    window.requestFileSystem = window.webkitRequestFileSystem || window.requestFileSystem;
    if (!window.webkitStorageInfo) {
        window.webkitStorageInfo = {
            requestQuota: function (type, bytes, successFn, errorFn) {
                errorFn(new Error("Not implemented"));
            }
        };
    }

    //wrap resolve/reject in an empty $timeout so it happens within the Angular call stack
    //easier than .apply() since no scope is needed and doesn't error if already within an apply
    function safeResolve(deferral, message) {
        $timeout(function () {
            deferral.resolve(message);
        });
    }

    function safeReject(deferral, message) {
        $timeout(function () {
            deferral.reject(message);
        });
    }

    let requestFsFn = function (bytes) {
        window.requestFileSystem(window.PERSISTENT, bytes, function (fs) {
            safeResolve(fsDefer, fs);
        }, function (e) {
            safeReject(fsDefer, {text: "Error requesting File System access", obj: e});
        });
    };

    window.webkitStorageInfo.requestQuota(window.PERSISTENT, DEFAULT_QUOTA_MB * 1024 * 1024, function (grantedBytes) {
        if (window.cordova) {
            document.addEventListener('deviceready', function () {
                requestFsFn(grantedBytes);
            }, false);
        } else {
            requestFsFn(grantedBytes);
        }
    }, function (e) {
        safeReject(fsDefer, {text: "Error requesting Quota", obj: e});
    });

    let fileSystem = {
        isSupported: function () {
            return angular.isDefined(window.webkitStorageInfo);
        },
        getCurrentUsage: function () {
            let def = $q.defer();

            webkitStorageInfo.queryUsageAndQuota(window.PERSISTENT, function (used, quota) {
                safeResolve(def, {'used': used, 'quota': quota});
            }, function (e) {
                safeReject(def, {text: "Error getting quota information", obj: e});
            });

            return def.promise;
        },
        requestQuota: function (newQuotaMB) {
            let def = $q.defer();

            window.webkitStorageInfo.requestQuota(window.PERSISTENT, newQuotaMB * 1024 * 1024, function (grantedBytes) {
                safeResolve(def, grantedBytes);
            }, function (e) {
                safeReject(def, {text: "Error requesting quota increase", obj: e});
            });

            return def.promise;
        },
        getFolderContents: function (path) {
            //remove leading slash if present
            path = path.replace(/^\//, "");

            let def = $q.defer();

            function getContent(rootDir, folders) {
                rootDir.getDirectory(folders[0], {}, function (dirEntry) {
                    let dirReader = dirEntry.createReader();
                    if (folders.length > 1) {
                        getContent(dirEntry, folders.slice(1));
                    } else {
                        dirReader.readEntries(function (entries) {
                            safeResolve(def, entries);
                        }, function (e) {
                            safeReject(def, {text: "Error reading entries", obj: e});
                        });
                    }
                }, function (e) {
                    safeReject(def, {text: "Error getting directory", obj: e});
                });
            }

            fsDefer.promise.then(function (fs) {
                getContent(fs.root, path.split('/'));
            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        createFolder: function (path) {
            //remove leading slash if present
            path = path.replace(/^\//, "");

            let def = $q.defer();

            function createDir(rootDir, folders) {
                rootDir.getDirectory(folders[0], {create: true}, function (dirEntry) {
                    if (folders.length > 1) {
                        createDir(dirEntry, folders.slice(1));
                    } else {
                        safeResolve(def, dirEntry);
                    }
                }, function (e) {
                    safeReject(def, {text: "Error creating directory", obj: e});
                });
            }

            fsDefer.promise.then(function (fs) {
                createDir(fs.root, path.split('/'));
            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        deleteFolder: function (path, recursive) {
            recursive = (typeof recursive == 'undefined' ? false : recursive);

            let def = $q.defer();

            fsDefer.promise.then(function (fs) {
                fs.root.getDirectory(path, {}, function (dirEntry) {
                    let success = function () {
                        safeResolve(def, "");
                    };
                    let err = function (e) {
                        safeReject(def, {text: "Error removing directory", obj: e});
                    };

                    if (recursive) {
                        dirEntry.removeRecursively(success, err);
                    } else {
                        dirEntry.remove(success, err);
                    }
                }, function (e) {
                    safeReject(def, {text: "Error getting directory", obj: e});
                });
            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        writeFileInput: function (filename, file, mimeString) {
            let def = $q.defer();

            let reader = new FileReader();

            reader.onload = function (e) {
                let buf = e.target.result;

                $timeout(function () {
                    fileSystem.writeArrayBuffer(filename, buf, mimeString).then(function () {
                        safeResolve(def, "");
                    }, function (e) {
                        safeReject(def, e);
                    });
                });
            };

            reader.readAsArrayBuffer(file);

            return def.promise;
        },
        writeText: function (fileName, contents, append) {
            append = (typeof append == 'undefined' ? false : append);

            //create text blob from string
            let blob = new Blob([contents], {type: 'text/plain'});

            return fileSystem.writeBlob(fileName, blob, append);
        },
        writeArrayBuffer: function (fileName, buf, mimeString, append) {
            append = (typeof append == 'undefined' ? false : append);

            let blob = new Blob([new Uint8Array(buf)], {type: mimeString});

            return fileSystem.writeBlob(fileName, blob, append);
        },
        writeBlob: function (fileName, blob, append) {
            append = (typeof append == 'undefined' ? false : append);

            let def = $q.defer();

            fsDefer.promise.then(function (fs) {

                fs.root.getFile(fileName, {create: true}, function (fileEntry) {

                    fileEntry.createWriter(function (fileWriter) {
                        if (append) {
                            fileWriter.seek(fileWriter.length);
                        }

                        let truncated = false;
                        fileWriter.onwriteend = function (e) {
                            //truncate all data after current position
                            if (!truncated) {
                                truncated = true;
                                this.truncate(this.position);
                                return;
                            }
                            safeResolve(def, "");
                        };

                        fileWriter.onerror = function (e) {
                            safeReject(def, {text: 'Write failed', obj: e});
                        };

                        fileWriter.write(blob);

                    }, function (e) {
                        safeReject(def, {text: "Error creating file", obj: e});
                    });

                }, function (e) {
                    safeReject(def, {text: "Error getting file", obj: e});
                });

            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        getFile: function (fileName) {
            let def = $q.defer();

            this.getFileEntry(fileName).then(function (fileEntry) {
                // Get a File object representing the file,
                fileEntry.file(function (file) {
                    safeResolve(def, file);
                }, function (e) {
                    safeReject(def, {text: "Error getting file object", obj: e});
                });
            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        getFileEntry: function (fileName) {
            let def = $q.defer();

            fsDefer.promise.then(function (fs) {
                fs.root.getFile(fileName, {}, function (fileEntry) {
                    safeResolve(def, fileEntry);
                }, function (e) {
                    safeReject(def, {text: "Error getting file", obj: e});
                });
            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        /**
         * @param  String Local filesystem URL.
         * @return Object Promise with a File argument.
         */
        getFileFromLocalFileSystemURL: function (url) {
            let def = $q.defer();
            window.resolveLocalFileSystemURL(
                url,
                function (fileEntry) {
                    fileEntry.file(
                        function (file) {
                            safeResolve(def, file);
                        }, function (e) {
                            safeReject(def, {text: "Error getting file object", obj: e});
                        }
                    );
                },
                function (e) {
                    safeReject(def, {text: "Error resolving FileSystem URL", obj: e});
                }
            );

            return def.promise;
        },
        readFile: function (fileName, returnType) {
            let def = $q.defer();

            returnType = returnType || "text";

            fsDefer.promise.then(function (fs) {
                fs.root.getFile(fileName, {}, function (fileEntry) {
                    // Get a File object representing the file,
                    // then use FileReader to read its contents.
                    fileEntry.file(function (file) {
                        let reader = new FileReader();

                        reader.onloadend = function () {
                            safeResolve(def, this.result);
                        };

                        reader.onerror = function (e) {
                            safeReject(def, {text: "Error reading file", obj: e});
                        };


                        switch (returnType) {
                            case 'arraybuffer':
                                reader.readAsArrayBuffer(file);
                                break;
                            case 'binarystring':
                                reader.readAsBinaryString(file);
                                break;
                            case 'dataurl':
                                reader.readAsDataURL(file);
                                break;
                            default:
                                reader.readAsText(file);
                        }
                    }, function (e) {
                        safeReject(def, {text: "Error getting file", obj: e});
                    });
                }, function (e) {
                    safeReject(def, {text: "Error getting file", obj: e});
                });
            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        deleteFile: function (fullPath) {
            let def = $q.defer();

            fsDefer.promise.then(function (fs) {
                fs.root.getFile(fullPath, {create: false}, function (fileEntry) {
                    fileEntry.remove(function () {
                        safeResolve(def, "");
                    }, function (e) {
                        safeReject(def, {text: "Error deleting file", obj: e});
                    });
                });
            }, function (err) {
                def.reject(err);
            });

            return def.promise;
        },
        downloadAndStore: function (url, fileName, contentType, flags) {
            let def = $q.defer();

            $http({
                url: url,
                method: "GET",
                skipAuthorization: true,
                responseType: "blob"
            }).then(function (response) {
                    fileSystem.writeBlob(fileName, response.data, contentType, false).then(function () {
                        safeResolve(def, "");
                    }, function (e) {
                        safeReject(def, {text: "Error deleting file", obj: e});
                    });
                },
                function (err) {
                    def.reject(err);
                });

            return def.promise;
        }
    };

    // Keep old name for backwards compatibility
    fileSystem.requestQuotaIncrease = fileSystem.requestQuota;

    return fileSystem;
}

export default FilesystemService;
